import {
  Container,
  Grid,
} from "@mui/material";
import { useEffect } from "react";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { getInvitationByIdNoAuth } from "../../api/invitations";
import { SomethingWentWrong } from "../../components/form/errors";
import { LoadingSpinner } from "../../components/loading-spinners";
import Logo from "../../components/Logo";
import FlexBox from "../../components/layouts/Flexbox";
import { useMutationWithDispatch } from "../../hooks/useMutationWithDispatch";
import ProjectDetails from ".";

interface FetchInvitationVariables {
  id: string;
  token: string;
}

type InvitationResponse = {
  success: boolean;
  data?: any;
  message?: string;
};

export default function ProjectDetailsNoAuth() {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const id = params?.id ?? null;

  const { data: response, isPending: loading, isError: fetchError, mutate } =
    useMutationWithDispatch<InvitationResponse, FetchInvitationVariables>(
      ({ id: invitationId, token: authToken }) =>
        getInvitationByIdNoAuth(invitationId, authToken)
    );

  const projectDetails = response?.data;

  useEffect(() => {
    if (!token || !id) return;
    mutate({ id, token });
  }, [id, token, mutate]);

  if (loading && !projectDetails) {
    return <LoadingSpinner loading />;
  }

  if (fetchError || !projectDetails || !token || !id) {
    return <Container>
      <FlexBox my={2} mb={5}>
        <Logo />
      </FlexBox>
      <SomethingWentWrong title="Invalid link" message="This invitation link is invalid or missing a token. Please use the link from your invitation email." />
    </Container>
  }

  return (
    <Container sx={{ my: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Logo />
        </Grid>
        <Grid item xs={12}>
          <ProjectDetails projectDetails={projectDetails} previewMode={true} />
        </Grid>
      </Grid>
    </Container>
  );
}
